import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { TableOfContents } from './TableOfContents';
import { DocumentSearch } from './DocumentSearch';
import type { TocItem } from '@/legal/utils/tocExtractor';

interface Props {
  items: TocItem[];
  content: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * TOC Drawer — controlled через open + onOpenChange. Trigger вынесен наружу
 * (LegalHeader: иконка-бургер на <lg). На desktop (≥lg) sidebar TOC видим,
 * drawer не открывается из шапки. Click по якорю внутри drawer — закрывает.
 */
export function MobileTocDrawer({ items, content, open, onOpenChange }: Props) {
  const { t } = useTranslation('legal');

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <Dialog.Content
          className="fixed inset-y-0 left-0 z-50 flex h-[100dvh] w-[85vw] max-w-sm flex-col overflow-hidden bg-surface-canvas shadow-xl data-[state=open]:animate-in data-[state=open]:slide-in-from-left"
          onClick={(e) => {
            const target = e.target as HTMLElement;
            if (target.closest('a[href^="#"]')) {
              setTimeout(() => onOpenChange(false), 150);
            }
          }}
        >
          <div className="flex shrink-0 items-center justify-between border-b border-border px-4 py-3">
            <Dialog.Title className="text-base font-semibold text-text-primary">
              {t('toc.label', 'Содержание')}
            </Dialog.Title>
            <Dialog.Close className="inline-flex h-8 w-8 items-center justify-center rounded-md text-text-secondary hover:bg-surface-subtle">
              <X className="h-4 w-4" aria-hidden />
              <span className="sr-only">Закрыть</span>
            </Dialog.Close>
          </div>
          <div className="flex-1 min-h-0 overflow-y-auto p-4">
            <DocumentSearch content={content} />
            <div className="mt-4">
              <TableOfContents items={items} />
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
